import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'SelfServeBuilder';
import { PrimaryButton } from 'DesignSystem/Buttons';

export default class PublishTemplateModalBody extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="publish-template-modal">
          <div className="header">
            <div className="modal-icon-container">
              <img
                src="/images/self-serve-builder/modals/share-template-modal-icon-2x.png"
                alt="Share"
              />
            </div>
            <h3>Sharing your document locks all editing features.</h3>
            <div className="modal-body-divider" />
          </div>
          <div>
            <ul>
              <li>Once you share this document, you will not be able to make any more edits.</li>
              <li>If you want to make changes later, you can always duplicate this document.</li>
              <li>Remember to preview your document before sharing.</li>
            </ul>
          </div>
          <div className="modal-buttons-container">
            <IconButton
              text="Cancel"
              containerClass="left"
              onClick={this.props.onCancel}
            />
            <PrimaryButton onClick={this.props.onPublish}>
              Publish Now
            </PrimaryButton>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PublishTemplateModalBody.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/PublishTemplateConfirmationModal/PublishTemplateModalBody.jsx